import { render } from "./DialogValidFramesWithQRComplete.vue?vue&type=template&id=277acb02"
import script from "./DialogValidFramesWithQRComplete.vue?vue&type=script&lang=js"
export * from "./DialogValidFramesWithQRComplete.vue?vue&type=script&lang=js"
script.render = render

export default script